//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
let d=[[[0,"ImportEntityType",1,0],[0,"ImportPolylineTo",1,0],[0,"IncludeModelSpace",1,0],[0,"IncludeSubfolders",1,0],[0,"InputFolder",1,0],[0,"LibraryPathName",1,0],[0,"PreserveFolderStructure",1,0],[0,"SelectMode",1,0],[0,"SettingsFile",1,0],[0,"SymbolType",1,0],[0,"Unit",1,0]],[[["folderName"],"AddFolder",{},1,0],[["fileName"],"AddFile",{},1,0],[["folderName"],"RemoveFolder",{},1,0],[["fileName"],"RemoveFile",{},1,0],[["folderName","isSelected"],"SelectFolder",{},2,0],[["fileName","isSelected"],"SelectFile",{},2,0],[["fileName","blockName","isSelected"],"SelectBlock",{},3,0]],[]];
SPLM.Annotations.ImportAutocadBlockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.ImportAutocadBlockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.ImportAutocadBlockBuilder.FileFolder = Object.freeze({
    "File" : "File", "Folder" : "Folder"});

SPLM.Annotations.ImportAutocadBlockBuilder.Type = Object.freeze({
    "Teamcenter" : "Teamcenter", "Part" : "Part", "Native" : "Native"});

SPLM.Annotations.ImportAutocadBlockBuilder.EntityType = Object.freeze({
    "Symbol" : "Symbol", "Component" : "Component"});

export default SPLM;